import React from 'react';
import { FormattedMessage } from 'react-intl';

import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';

export const getCreateButtonDisabledMessage = (
	isContentArchived?: boolean,
	userCanAddComments?: boolean,
	needsUpdateToComment?: boolean,
	contentType?: 'page' | 'blogpost' | 'whiteboard' | 'database' | 'embed' | 'slide' | 'folder',
) => {
	if (isContentArchived) {
		return (
			<FormattedMessage
				id="highlight-actions.inline-comments.comment.unsupported.archive"
				description="Tooltip for the unsupported inline comment for the archive page"
				defaultMessage="Comments can’t be added to archived items"
			/>
		);
	} else if (!userCanAddComments) {
		return (
			<FormattedMessage
				id="highlight-actions.inline-comments.comment.no.permission"
				description="Tooltip for when the user does not have permission to add inline comments"
				defaultMessage="{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}"
				values={{ contentType }}
			/>
		);
	} else if (needsUpdateToComment) {
		return (
			<FormattedMessage
				id="highlight-actions.inline-comments.comment.needs.update"
				description="Tooltip for when document is outdated and thus user-selected content type cannot be commented on"
				defaultMessage="Page is outdated, refresh to comment"
			/>
		);
	} else if (expVal('platform_synced_block', 'isEnabled', false)) {
		return (
			<FormattedMessage
				id="highlight-actions.inline-comments.comment.unable.to.create"
				description="Tooltip for the unsupported inline comment on the content"
				defaultMessage="Unable to comment on this element"
			/>
		);
	} else {
		return fg('editor_inline_comments_on_inline_nodes') ? (
			<FormattedMessage
				id="highlight-actions.inline-comments.comment.create.disabled"
				description="Error message to communicate to the user they can only do the current action in certain contexts"
				defaultMessage="You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
			/>
		) : (
			<FormattedMessage
				id="highlight-actions.inline-comments.comment.unsupported"
				description="Tooltip for the unsupported inline comment on the content that contains an emoji, a macro, or an @mention"
				defaultMessage="Comments can only be added to text that doesn’t contain an emoji, a macro, or an @mention"
			/>
		);
	}
};
